import Constants from "./constants";
import store from "../store";

const baseUri = `${Constants.mode}://${Constants.domain}:${Constants.port}/api/v1`;
const pdfUri = `${Constants.mode}://${Constants.domain}`;

const header = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

const headerFormData = {
  Accept: "application/json",
};

export const HttpMethod = Object.freeze({
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
});

const createUri = (url, pdf) => {
  return `${pdf ? pdfUri : baseUri}/${url}`;
};

export const initFetch = (
  url,
  method,
  options = { Authorization: true, formData: false, pdf: false }
) => {
  const customHeader = options.formData ? headerFormData : header;
  if (options.Authorization === true) {
    const state = store.getState();
    const authToken = state.utilisateur.data.token;

    customHeader["Authorization"] = `Bearer ${authToken}`;
  }

  return { url: createUri(url, options.pdf), params: { method: method, headers: customHeader } };
};

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Nombre de tentatives supplémentaires après l'appel initial (donc 4 essais au total).
const MAX_RETRIES_ON_RATE_LIMIT = 3;
const MAX_RETRIES_ON_NETWORK_FAILURE = 3;
// Utilisé uniquement si le serveur ne renvoie pas l'en-tête Retry-After.
const DEFAULT_RETRY_DELAY_MS = 1000;

// Ce wrapper absorbe deux types de pannes distincts et non exclusifs sur fetch() :
// - le rate limiting HTTP 429 (endpoints coûteux côté serveur, ex. rendu PDF) : la réponse
//   reste une Response valide, on relance en respectant Retry-After si présent, sinon un
//   backoff exponentiel (1s, 2s, 4s...) ;
// - l'échec réseau (TypeError "Failed to fetch" : timeout, connexion refusée, DNS...), qui
//   ne produit jamais de Response et fait rejeter fetch() : on relance avec le même type de
//   backoff.
// Objectif : que l'appelant n'ait pas à connaître ni gérer lui-même ces deux cas, tant que
// ses appels restent isolés (pas de retry sur une erreur métier type 400/500).
export const fetchWithRetry = async (url, params, attempt = 0) => {
  let response;
  try {
    response = await fetch(url, params);
  } catch (err) {
    if (attempt < MAX_RETRIES_ON_NETWORK_FAILURE) {
      await wait(DEFAULT_RETRY_DELAY_MS * 2 ** attempt);
      return fetchWithRetry(url, params, attempt + 1);
    }
    throw err;
  }

  if (response.status === 429 && attempt < MAX_RETRIES_ON_RATE_LIMIT) {
    const retryAfterHeader = response.headers.get("Retry-After");
    const delay = retryAfterHeader
      ? parseFloat(retryAfterHeader) * 1000
      : DEFAULT_RETRY_DELAY_MS * 2 ** attempt;

    await wait(delay);
    return fetchWithRetry(url, params, attempt + 1);
  }

  return response;
};
